<template>
  <div
    v-if="
      getFolders.length == 0 && searchInGroups == '' && searchInsideFolder == ''
    "
    class="
      teams-main-container teams-main-container-height
      mt-3
      d-flex
      flex-column
      align-items-center
      justify-content-center
      relativeclass
    "
  >
    <img src="../../assets/New-imgs/teams-icons/teams_tree_empty.svg" alt="" />
    <div class="teams-empty-container-font mt-3">
      There are no groups . Please click the “+&nbsp;&nbsp;Group” button to
      create new.
    </div>
  </div>
  <div
    v-else
    class="teams-main-container mt-3 d-flex relativeclass"
    style="height: calc(100vh - 174px)"
  >
    <div
      style="
        position: fixed;
        top: 20px;
        left: 0;
        z-index: 1;
        backdrop-filter: blur(2px);
      "
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div
      class="teams-left-container"
      id="style-scrollbar"
      style="height: calc(100vh - 208px)"
    >
      <div class="relativeclass teams-innerInputField">
        <img
          class="teams-setImage"
          src="../../assets/img/search-bar-icon.svg"
          alt=""
        />

        <b-form-input
          placeholder="Search in Groups"
          v-model.trim="searchInGroups"
          @update="searchGroups"
          debounce="500"
          type="search"
          class="search-input"
        >
        </b-form-input>
      </div>

      <hr class="mb-2" />
      <div class="mb-2 teams-group-head">Groups</div>
      <div class="teams-group-container-height" id="teams-group-scrollbar">
        <div
          v-if="searchInGroups !== '' && organizationData.length == 0"
          class="
            d-flex
            h-100
            flex-column
            align-items-center
            justify-content-center
          "
        >
          <img
            src="../../assets/New-imgs/teams-icons/teams-no-matching-results.svg"
            alt=""
          />
          <div class="teams-empty-container-font mt-3">
            No matching results for "{{ searchInGroups }}"
          </div>
        </div>
        <vue-tree-list
          v-else
          class="teams-list-view"
          ref="treeView"
          :model="treeData"
          @click="selectNode"
          :default-expanded="false"
        >
          <template v-slot:treeNodeIcon="slotProps">
            <span class="icon">
              <img
                v-if="
                  slotProps.model.children &&
                  slotProps.model.children.length > 0 &&
                  !slotProps.expanded
                "
                class="mr-2"
                src="../../assets/New-imgs/teams-icons/teams-right-arrow.svg"
                alt="" />
              <img
                v-if="
                  slotProps.model.children &&
                  slotProps.model.children.length > 0 &&
                  slotProps.expanded
                "
                class="mr-2"
                src="../../assets/New-imgs/teams-icons/teams-down-arrow.svg"
                alt=""
            /></span>
          </template>
        </vue-tree-list>
      </div>
    </div>
    <!-- right side content part -->

    <div
      class="teams-new-right-container ml-2"
      :style="
        !showAddUser
          ? 'display: flex; justify-content: center;align-items: center;'
          : ''
      "
    >
      <div v-if="showAddUser" class="w-100">
        <div
          class="d-flex align-items-center justify-content-between mt-2 w-100"
        >
          <div>
            <div class="teams-new-right-container-head">
              {{ currentFolder }}
            </div>

            <div>
              <span class="teams-new-right-container-subhead"> Teams </span>
              <span v-for="folder in folderUp" :key="folder.folderID">
                <span v-if="folderUp.length != 0">
                  <span class="ml-2">
                    <img
                      src="../../assets/New-imgs/teams-icons/teams-head-right-arrow.svg"
                      alt=""
                    />
                  </span>
                  <span
                    class="teams-new-right-container-subhead ml-2 pointer"
                    @click="goInsideFolder(folder.folderID)"
                  >
                    {{ folder.folderName }}
                  </span>
                </span>
              </span>
              <span class="ml-2">
                <img
                  src="../../assets/New-imgs/teams-icons/teams-head-right-arrow.svg"
                  alt=""
                />
              </span>
              <span class="teams-new-right-container-subchild ml-2">
                {{ currentFolder }}
              </span>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div
              class="pointer"
              v-if="
                roles.includes('PUT_TEAMS') && currentFolder !== 'All Users'
              "
              @click="assignFolderName(getFolderContent)"
            >
              <img
                class="newIcons-hover"
                src="../../assets/New-imgs/teams-icons/teams-edit-icon.svg"
                alt=""
              />
            </div>
            <div
              v-if="
                roles.includes('DELETE_TEAMS') && currentFolder !== 'All Users'
              "
              class="ml-3 pointer"
              @click="
                (deleteFromInside = false), assignFolder(getFolderContent)
              "
            >
              <img
                class="newIcons-hover"
                src="../../assets/New-imgs/teams-icons/teams-delete-icon.svg"
                alt=""
              />
            </div>
            <div class="ml-3" v-if="roles.includes('TAG_USER')">
              <b-button
                class="
                  new-blueBtn
                  w-100
                  d-flex
                  align-items-center
                  justify-content-center
                "
                @click="openTagUsers = true"
                :disabled="
                  currentFolder == 'All Users' || !roles.includes('TAG_USER')
                "
              >
                <img
                  src="../../assets/New-imgs/teams-icons/plus-btn.svg"
                  alt=""
                  class="mr-2"
                />
                <span> Tag Users </span>
              </b-button>
            </div>
            <div class="ml-3" v-if="roles.includes('PUSH_TEAMS')">
              <b-button
                v-b-modal.addSubFolder
                class="
                  new-blueBtn
                  w-100
                  d-flex
                  align-items-center
                  justify-content-center
                "
                :disabled="
                  currentFolder == 'All Users' || !roles.includes('PUSH_TEAMS')
                "
              >
                <img
                  src="../../assets/New-imgs/teams-icons/plus-btn.svg"
                  alt=""
                  class="mr-2"
                />
                <span> Sub Group </span>
              </b-button>
            </div>
          </div>
        </div>
        <hr />
        <div
          v-if="
            !showApplyFilter &&
            childFolders.length == 0 &&
            users.length == 0 &&
            searchInsideFolder == ''
          "
          class="d-flex flex-column align-items-center justify-content-center"
          style="
            height: calc(100vh - 347px);
            overflow-x: hidden;
            overflow-y: auto;
          "
        >
          <img
            src="../../assets/New-imgs/teams-icons/teams_no_folder_content.svg"
            alt=""
          />
          <div class="teams-empty-container-font mt-3">
            There are no sub-groups or users. Please click the “+&nbsp;&nbsp;Sub
            Group” or "+&nbsp;&nbsp;Tag Users" button to add new.
          </div>
        </div>
        <div v-else class="p-2">
          <div class="d-flex align-items-center">
            <div class="relativeclass teams-innerInputField" style="width: 90%">
              <img
                class="teams-setImage"
                src="../../assets/img/search-bar-icon.svg"
                alt=""
              />

              <b-form-input
                :placeholder="`Search in ${currentFolder}`"
                v-model.trim="searchInsideFolder"
                @update="getFolderDetails(getFolderContent.folderID)"
                debounce="500"
                type="search"
                class="search-input"
              >
              </b-form-input>
            </div>
            <div class="ml-3 mr-3 relativeclass">
              <b-button
                ref="filterbutton"
                @click="
                  showTeamsFilter ? hideFilter() : (showTeamsFilter = true),
                    getRolesDetails()
                "
                class="
                  new-blueBtn
                  w-100
                  d-flex
                  align-items-center
                  justify-content-center
                "
              >
                <img
                  src="../../assets/New-imgs/teams-icons/white-filter-icon.svg"
                  alt=""
                  class="mr-2"
                />
                <div
                  class="teams-filter-applied mb-3 pointer"
                  v-if="showApplyFilter"
                >
                  <img src="../../assets/panelist/fil_selected.svg" alt="" />
                </div>
                <span> Filter </span>
              </b-button>

              <div
                refs="filter"
                v-if="showTeamsFilter"
                class="acs-filter p-3"
                style="width: 300px; top: 38px; right: 2px"
                v-closable="{
                  exclude: ['filter', 'filterbutton'],
                  handler: 'hideFilter',
                }"
              >
                <!-- type -->
                <div>
                  <div class="acs-black-txt">Type:</div>
                  <div
                    class="
                      mt-1
                      teams-filter-inputField
                      d-flex
                      justify-content-between
                      pointer
                    "
                    @click="(showType = !showType), (showUserRole = false)"
                  >
                    <span
                      class="choose-source-class"
                      v-if="typeOptionSelected == ''"
                      >Select</span
                    >
                    <span
                      style="text-transform: capitalize"
                      class="newManage-dropdown-place"
                      v-else
                    >
                      {{
                        typeOptionSelected === "0"
                          ? "All"
                          : typeOptionSelected === "1"
                          ? "Users"
                          : "Groups"
                      }}
                    </span>
                    <span>
                      <img
                        src="../../assets/New-imgs/teams-icons/teams-down-arrow.svg"
                        alt=""
                        class="mr-1"
                      />
                    </span>
                  </div>
                  <div v-if="showType" class="relativeclass">
                    <div class="newInt-radio-dropdown p-0">
                      <b-form-group class="sec-mcq-datacard">
                        <b-form-radio-group
                          @change="
                            typeOptionSelected == '2'
                              ? ((showType = !showType),
                                (showUserRole = false),
                                (userRoleSelected = []))
                              : (showType = !showType)
                          "
                          class="newInt-radio-dropdown-inner-content w-100"
                          :options="typeOptions"
                          v-model="typeOptionSelected"
                          placeholder="Enter Role"
                          disabled-field="notEnabled"
                          text-field="text"
                          value-field="value"
                          buttons
                          stacked
                        >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>

                <!-- user Role -->
                <div class="mt-3">
                  <div class="acs-black-txt">User Role:</div>
                  <div
                    class="mt-1 d-flex justify-content-between"
                    :class="
                      typeOptionSelected == '2'
                        ? 'teams-filter-inputField-disabled'
                        : 'teams-filter-inputField pointer'
                    "
                    @click="
                      typeOptionSelected == '2'
                        ? (showUserRole = false)
                        : ((showUserRole = !showUserRole), (showType = false))
                    "
                  >
                    <span
                      class="choose-source-class"
                      v-if="userRoleSelected && userRoleSelected.length == 0"
                      >Select Role</span
                    >
                    <span
                      style="
                        text-transform: capitalize;
                        min-width: auto;
                        max-width: 85%;
                      "
                      v-else
                      class="text-truncate newManage-dropdown-place"
                    >
                      {{ formattedUserRoles }}
                    </span>
                    <span>
                      <img
                        src="../../assets/New-imgs/teams-icons/teams-down-arrow.svg"
                        alt=""
                        class="mr-1"
                      />
                    </span>
                  </div>
                  <div
                    v-if="showUserRole"
                    class="
                      selectCustom-dropdown
                      pointer
                      newManage-checkbox
                      selectCustom-dropdown-text
                      d-flex
                    "
                    style="width: 87%"
                  >
                    <b-form-checkbox-group
                      v-model="userRoleSelected"
                      :options="userRoleOptions"
                      class="w-100 selectCustom-dropdown-innerContent"
                      disabled-field="notEnabled"
                      value-field="roleName"
                      text-field="roleName"
                      :disabled="typeOptionSelected == '2'"
                    ></b-form-checkbox-group>
                  </div>
                </div>

                <div class="d-flex justify-content-between mt-4 bluebtn">
                  <b-button
                    class="acs-cancelBtn-filter"
                    @click="showTeamsFilter = false"
                    >Cancel</b-button
                  >
                  <div class="d-flex">
                    <b-button
                      class="acs-cancelBtn-filter mr-3"
                      @click="clearFilter(getFolderContent.folderID)"
                      :disabled="
                        userRoleSelected.length == 0 && typeOptionSelected == ''
                      "
                      >Reset</b-button
                    >
                    <b-button
                      class="acs-cancelBtn-filter"
                      :disabled="
                        userRoleSelected.length == 0 && typeOptionSelected == ''
                      "
                      @click="applyFilter(getFolderContent.folderID)"
                      >Apply</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- users div starts from here -->
          <div class="teams-user-container mt-3">
            <div
              v-if="
                searchInsideFolder !== '' &&
                childFolders.length == 0 &&
                users.length == 0
              "
              class="
                d-flex
                h-100
                flex-column
                align-items-center
                justify-content-center
              "
            >
              <img
                src="../../assets/New-imgs/teams-icons/teams-no-matching-results.svg"
                alt=""
              />
              <div class="teams-empty-container-font mt-3">
                No matching results for "{{ searchInsideFolder }}".
              </div>
            </div>
            <div
              v-else-if="
                showApplyFilter && users.length == 0 && childFolders.length == 0
              "
              class="
                d-flex
                h-100
                flex-column
                align-items-center
                justify-content-center
              "
            >
              <img
                src="../../assets/New-imgs/teams-icons/teams-no-matching-results.svg"
                alt=""
              />
              <div class="teams-empty-container-font mt-3">
                No matching results.
              </div>
            </div>
            <template
              v-if="
                typeSelected === '' ||
                typeSelected === '0' ||
                typeSelected === '2'
              "
            >
              <div
                class="
                  d-flex
                  align-items-center
                  teams-user-inner-container
                  relativeclass
                  pointer
                "
                :class="childIndex > 0 ? 'mt-3' : ''"
                v-for="(child, childIndex) in childFolders"
                :key="child.folderID"
                @click="goInsideFolder(child.folderID)"
              >
                <div
                  class="text-left gridgreencolorDynamic mr-1"
                  style="background: #5863b3"
                ></div>

                <div style="width: 5%" class="text-center">
                  <img
                    src="../../assets/New-imgs/teams-icons/teams-big-folder.svg"
                    alt=""
                  />
                </div>
                <div style="width: 30%" class="ml-2">
                  <div class="teams-user-inner-container-head text-truncate">
                    {{ child.folderName }}
                  </div>
                  <div class="teams-user-inner-container-createdAt">
                    Created On: {{ child.createdAt | formatChildDate }}
                  </div>
                </div>

                <div class="d-flex align-items-center" style="width: 10%">
                  <div>
                    <img
                      src="../../assets/New-imgs/teams-icons/teams-small-folder.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-2 teams-user-inner-container-count mt-1">
                    {{ child.noOfFolders }}
                  </div>
                </div>

                <div class="d-flex align-items-center" style="width: 10%">
                  <div>
                    <img
                      src="../../assets/New-imgs/teams-icons/teams-small-user.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-2 teams-user-inner-container-count mt-1">
                    {{ child.users.length }}
                  </div>
                </div>

                <div
                  style="width: 35%"
                  class="d-flex align-items-center justify-content-center"
                >
                  <template v-if="child.users && child.users.length == 0">
                    <div class="text-center">-</div>
                  </template>
                  <template v-else>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-center
                        position-relative
                      "
                      :style="
                        child.users && child.users.length > 3
                          ? 'width: 100px'
                          : child.users && child.users.length == 3
                          ? 'width: 70px;'
                          : child.users && child.users.length == 2
                          ? 'width: 45px;'
                          : child.users && child.users.length == 1
                          ? 'width: 20px;'
                          : ''
                      "
                    >
                      <div
                        v-if="child.users && child.users.length > 0"
                        class="roundDarkBlue"
                        style="left: 0px"
                        v-b-tooltip.hover.top="child.users[0].username"
                      >
                        {{ child.users[0].userIcon }}
                      </div>
                      <div
                        v-if="child.users && child.users.length > 1"
                        class="roundDarkBlue"
                        style="left: 25px"
                        v-b-tooltip.hover.top="child.users[1].username"
                      >
                        {{ child.users[1].userIcon }}
                      </div>
                      <div
                        v-if="child.users && child.users.length > 2"
                        class="roundDarkBlue"
                        style="left: 50px"
                        v-b-tooltip.hover.top="child.users[2].username"
                      >
                        {{ child.users[2].userIcon }}
                      </div>
                      <div
                        v-if="child.users && child.users.length == 4"
                        class="roundDarkBlue"
                        style="left: 75px"
                        v-b-tooltip.hover.top="child.users[3].username"
                      >
                        {{ child.users[3].userIcon }}
                      </div>
                      <div
                        v-if="child.users && child.users.length > 4"
                        class="roundLightBlue"
                        style="left: 75px"
                        v-b-tooltip.hover.top="
                          getRemainingNamesTooltip(child.users)
                        "
                      >
                        +{{ child.users.length - 3 }}
                      </div>
                    </div>
                  </template>
                </div>

                <div
                  v-if="roles.includes('DELETE_TEAMS')"
                  style="width: 10%"
                  class="d-flex align-items-center justify-content-end pr-4"
                  @click.stop="
                    (deleteFromInside = true),
                      (deleteType = true),
                      assignFolder(child)
                  "
                >
                  <img
                    src="../../assets/New-imgs/teams-icons/teams-user-folder-delete.svg"
                    alt=""
                    class="pointer"
                  />
                </div>
              </div>
            </template>
            <template
              v-else-if="
                showApplyFilter &&
                searchInsideFolder == '' &&
                users.length === 0
              "
            >
              <div
                class="
                  d-flex
                  h-100
                  flex-column
                  align-items-center
                  justify-content-center
                "
              >
                <img
                  src="../../assets/New-imgs/teams-icons/teams-no-matching-results.svg"
                  alt=""
                />
                <div class="teams-empty-container-font mt-3">
                  No matching results.
                </div>
              </div>
            </template>

            <template
              v-if="
                typeSelected === '' ||
                typeSelected === '0' ||
                typeSelected === '1'
              "
            >
              <div
                class="
                  d-flex
                  align-items-center
                  teams-user-inner-container
                  relativeclass
                  mt-3
                "
                v-for="(user, userIndex) in users"
                :key="userIndex"
              >
                <div
                  class="text-left gridgreencolorDynamic mr-1"
                  style="background: #5863b3"
                ></div>

                <div style="width: 5%" class="text-center">
                  <img
                    src="../../assets/New-imgs/teams-icons/teams-big-user.svg"
                    alt=""
                  />
                </div>
                <div
                  style="width: 30%"
                  class="ml-2 teams-user-inner-container-head text-truncate"
                >
                  {{ user.username }}
                </div>

                <div
                  class="
                    d-flex
                    align-items-center
                    teams-user-inner-container-head
                    text-truncate
                  "
                  style="width: 30%"
                >
                  {{ user.email }}
                </div>

                <div
                  style="width: 25%"
                  v-b-tooltip.hover.top="user.roleName"
                  class="teams-user-inner-container-head pl-5"
                >
                  {{ user.roleName }}
                </div>
                <div
                  v-if="
                    currentFolder !== 'All Users' &&
                    roles.includes('DELETE_TAGGED_USER')
                  "
                  class="d-flex align-items-center justify-content-end pr-4"
                  style="width: 10%"
                  @click.stop="assignUser(user)"
                >
                  <img
                    src="../../assets/New-imgs/teams-icons/teams-user-folder-delete.svg"
                    alt=""
                    class="pointer"
                  />
                </div>
              </div>
            </template>
            <template
              v-else-if="
                showApplyFilter &&
                searchInsideFolder == '' &&
                childFolders.length === 0
              "
            >
              <div
                class="
                  d-flex
                  h-100
                  flex-column
                  align-items-center
                  justify-content-center
                "
              >
                <img
                  src="../../assets/New-imgs/teams-icons/teams-no-matching-results.svg"
                  alt=""
                />
                <div class="teams-empty-container-font mt-3">
                  No matching results.
                </div>
              </div>
            </template>
          </div>

          <div class="d-flex align-items-center justify-content-end w-100 mt-2">
            <div
              v-if="typeSelected !== '1'"
              class="d-flex align-items-center teams-user-footer-content"
            >
              <div>
                <img
                  src="../../assets/New-imgs/teams-icons/teams-very-small-folder.svg"
                  alt=""
                />
              </div>
              <div class="ml-2">
                {{ folderCount }}
              </div>
            </div>

            <div
              v-if="typeSelected !== '2'"
              class="d-flex align-items-center ml-3 teams-user-footer-content"
            >
              <div>
                <img
                  src="../../assets/New-imgs/teams-icons/teams-very-small-user.svg"
                  alt=""
                />
              </div>
              <div class="ml-2">
                {{ userCount }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center">
        <img
          src="../../assets/New-imgs/teams-icons/teams_no_folder_selected.svg"
          alt=""
        />
        <div class="teams-empty-container-font mt-3">
          Please select any group on the left side to view its sub-groups and
          <br />
          users that have been created.
        </div>
      </div>
    </div>

    <!-- delete main folder-->
    <b-modal
      id="delete-folder"
      ref="deleteFolderModal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="(deleteType = false),
              closeModel('delete-folder')"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div>
            <img
              src="../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
              alt=""
            />
          </div>
          <div class="mt-3 ml-2">
            <div class="teams-modal-head">Delete {{ getType("header") }}</div>
            <div class="mt-1 teams-delete-folder-font">
              This {{ getType("text") }} along with all associated
              sub-groups/users within it will also be removed.
            </div>
          </div>
        </div>
        <div
          @click="
            showSpinnerCircle ? '' : (deleteType = false),
              closeModel('delete-folder')
          "
        >
          <img
            src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
            class="pointer rotate-on-hover"
          />
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end mt-2">
        <b-button
          :disabled="showSpinnerCircle"
          class="new-whiteBtn mr-3"
          @click="(deleteType = false), closeModel('delete-folder')"
          >Cancel</b-button
        >
        <b-button
          :class="
            showSpinnerCircle
              ? ' acs-addBtn-modal mp-loader-class defaultCursor'
              : ' acs-addBtn-modal pointer'
          "
          @click="showSpinnerCircle ? '' : deleteFolder()"
        >
          <span v-if="!showSpinnerCircle">Delete</span></b-button
        >
        <div v-if="showSpinnerCircle" class="loader-pos"><Loader /></div>
      </div>
    </b-modal>

    <!-- delete main user modal -->
    <b-modal
      id="delete-user"
      ref="deleteUserModal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="closeModel('delete-user')"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div>
            <img
              src="../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
              alt=""
            />
          </div>
          <div class="mt-3 ml-2">
            <div class="teams-modal-head">Remove Tagged User</div>
            <div class="mt-1 teams-delete-folder-font">
              The user will be untagged and will not be able to access actions
              associated with this group.
            </div>
          </div>
        </div>
        <div @click="showSpinnerCircle ? '' : closeModel('delete-user')">
          <img
            src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
            class="pointer rotate-on-hover"
          />
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end mt-2">
        <b-button
          :disabled="showSpinnerCircle"
          class="new-whiteBtn mr-3"
          @click="closeModel('delete-user')"
          >Cancel</b-button
        >
        <b-button
          :class="
            showSpinnerCircle
              ? ' acs-addBtn-modal mp-loader-class defaultCursor'
              : ' acs-addBtn-modal pointer'
          "
          @click="showSpinnerCircle ? '' : deleteUser()"
          ><span v-if="!showSpinnerCircle">Remove</span></b-button
        >
        <div v-if="showSpinnerCircle" class="loader-pos"><Loader /></div>
      </div>
    </b-modal>

    <!-- rename Folder -->
    <b-modal
      id="rename-folder"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="closeModel('rename-folder')"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="teams-modal-head">Rename Group</div>
        <div @click="closeModel('rename-folder')">
          <img
            src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
            class="pointer rotate-on-hover"
          />
        </div>
      </div>
      <div class="mt-3">
        <div class="topDiv">
          <label class="teams-label-font">Group Name</label>
          <b-form-input
            class="mt-2 teams-inputField"
            type="text"
            placeholder="Enter Group Name"
            v-model.trim="renameFolder.folderName"
            :class="{ error: renameFolder.folderName.length == 0 }"
            @keyup.enter="rename"
            autofocus
          ></b-form-input>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-5">
        <b-button class="new-whiteBtn mr-3" @click="closeModel('rename-folder')"
          >Cancel</b-button
        >
        <b-button
          class="new-blueBtn"
          @click="rename"
          :disabled="renameFolder.folderName == ''"
          >Update</b-button
        >
      </div>
    </b-modal>

    <!-- add sub folder modal -->
    <b-modal
      id="addSubFolder"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="(folderName = ''), closeModel('addSubFolder')"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="teams-modal-head">New Sub Group</div>
        <div @click="(folderName = ''), closeModel('addSubFolder')">
          <img
            src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
            class="pointer rotate-on-hover"
          />
        </div>
      </div>
      <div class="mt-3">
        <div class="topDiv">
          <label class="teams-label-font">Sub Group Name</label>
          <b-form-input
            class="mt-2 teams-inputField"
            type="text"
            placeholder="Enter Sub Group Name"
            v-model.trim="$v.folderName.$model"
            :class="{ 'teams-inputField-error': $v.folderName.$error }"
            @keyup.enter="$v.folderName.$error ? '' : createFolder()"
            autofocus
          ></b-form-input>
          <div
            v-if="$v.folderName.$dirty && !$v.folderName.required"
            class="errortxt mt-1"
          >
            Required
          </div>
          <div
            v-else-if="$v.folderName.$dirty && !$v.folderName.maxLength"
            class="errortxt mt-1"
          >
            Max char length exceeded
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-5">
        <b-button
          class="new-whiteBtn mr-3"
          @click="(folderName = ''), closeModel('addSubFolder')"
          >Cancel</b-button
        >
        <b-button
          class="new-blueBtn"
          @click="createFolder"
          :disabled="$v.folderName.$error"
          >Create</b-button
        >
      </div>
    </b-modal>
    <TagUsers :openTagUsers="openTagUsers" @close-tag-users="onCloseTagUsers" />
  </div>
</template>

<script>
import EventBus from "../../utils/eventBus.js";
import { mapGetters } from "vuex";
import { VueTreeList, Tree } from "vue-tree-list";
import {
  addFolderUser,
  deleteFolderUser,
  addFolder,
  getRolesDetails,
} from "../../utils/apiFunctions";
import toast from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import Loader from "../../components/fixedcomponents/Loader.vue";
import { maxLength, required } from "vuelidate/lib/validators";
import teamsMixin from "../../components/mixin/teamsMixin";
import TagUsers from "./modal/TagUsers.vue";
export default {
  name: "TeamsFolder",
  components: {
    Spinner,
    VueTreeList,
    Loader,
    TagUsers,
  },
  data() {
    return {
      //NUMBERS
      tabIndex: 0,
      folderCount: null,
      userCount: null,

      // ARRAYS
      folders: [],
      childFolders: [],
      users: [],
      expandedFolders: [],
      typeOptions: [
        { text: "All", value: "0" },
        { text: "Users", value: "1" },
        { text: "Groups", value: "2" },
      ],
      userRoleOptions: [],
      organizationData: [],
      folderUp: [],
      treeData: null,
      deleteType: null,

      // STRINGS
      currentFolder: "",
      folderName: "",
      createdDate: "",
      folderId: "",
      typeSelected: "",
      typeOptionSelected: "",
      searchInGroups: "",

      // OBJECTS
      renameFolder: {
        folderName: "",
      },
      deleteSelectedFolder: {},
      deleteSelectedUser: {},

      // BOOLEANS
      renameChild: false,
      showUser: false,
      showSpinnerCircle: false,
      showType: false,
      showTeamsFilter: false,
      showUserRole: false,
      showApplyFilter: false,
      deleteFromInside: false,
      openTagUsers: false,
    };
  },
  validations() {
    return {
      folderName: {
        required,
        maxLength: maxLength(50),
      },
    };
  },
  async created() {
    if (this.getActive !== "") {
      this.getSelectedFolder();
    }
    this.$store.commit("teamsVUEX/addFolderContent", {});
    if (this.getActive == "") {
      await this.getAllFolders();
    }
    this.getFolderDetails();
    this.loadOrganizationData();
    this.getRolesDetails();
    window.addEventListener("keyup", this.handleKeyUp);
    EventBus.$on("on-create", this.onCreate);
  },
  async mounted() {
    if (this.getActive !== "") {
      this.toggleFileTree();
      await this.setStyle();
      document
        .getElementById(this.getActive)
        .scrollIntoView({ behavior: "smooth" });
    }
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.handleKeyUp);
    EventBus.$off("on-create", this.onCreate);
  },
  mixins: [toast, teamsMixin],
  filters: {
    formatChildDate(data) {
      if (!data) return "-";
      let formattedDate = data.slice(0, 10).split("-").reverse().join("-");
      return formattedDate;
    },
  },
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("teamsVUEX", {
      getFolderContent: "getFolderContent",
    }),
    ...mapGetters("teamsVUEX", {
      getFolders: "getFolders",
    }),
    ...mapGetters("teamsVUEX", {
      getUserAdded: "getUserAdded",
    }),
    ...mapGetters("teamsVUEX", {
      LoaderStatus: "getLoaderStatus",
    }),
    ...mapGetters("teamsVUEX", {
      getFetch: "getFetch",
    }),
    showAddUser() {
      return Object.keys(this.getFolderContent).length != 0;
    },
    // FORMAT DATE AS REQUIRED
    formatDate() {
      let format = "dd-MM-yyyy";
      const date = new Date(this.getFolderContent.createdAt);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      format = format.replace("MM", month.toString().padStart(2, "0"));
      if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
      } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().slice(2, 2));
      }
      format = format.replace("dd", day.toString().padStart(2, "0"));
      return format;
    },

    formattedUserRoles() {
      if (Array.isArray(this.userRoleSelected)) {
        if (this.userRoleSelected.length > 3) {
          return this.userRoleSelected.slice(0, 3).join(", ") + ", ...";
        }
        return this.userRoleSelected.join(", ");
      }
      return this.userRoleSelected;
    },
  },
  watch: {
    getFolderContent(newValue, oldValue) {
      if (newValue != oldValue) {
        this.childFolders = this.getFolderContent.childFolders;
        if (this.childFolders && this.childFolders.length != 0) {
          this.setUserIcon();
        }
        this.users = this.getFolderContent.users;
        this.currentFolder = this.getFolderContent.folderName;
        this.folderCount = this.getFolderContent.folderCount;
        this.userCount = this.getFolderContent.userCount;
        this.createdDate = this.formatDate;
      }
    },
    getFolders(newValue) {
      this.folders = newValue;
    },
    getFetch(newValue, oldValue) {
      if (newValue != oldValue) {
        this.executeMethods();
        this.getFolderDetails(this.getFolderContent.folderID);
      }
    },
    getUserAdded() {
      this.tabIndex = 1;
    },
    tabIndex() {
      this.searchInsideFolder = "";
    },
  },
  methods: {
    getType(value) {
      let textVal;
      if (this.getFolderContent?.root && !this.deleteType) {
        textVal = value == "header" ? "Group" : "group";
      } else textVal = value == "header" ? "Sub Group" : "sub group";
      return textVal;
    },
    getRemainingNamesTooltip(users) {
      const remainingNames = users.slice(3).map((user) => user.username);
      return remainingNames.join(", ");
    },
    onCloseTagUsers() {
      this.openTagUsers = false;
      this.folderUp = {};
      this.getSelectedFolder();
    },
    async goInsideFolder(folderID) {
      this.$store.commit("teamsVUEX/setActive", folderID);
      this.searchInsideFolder = "";
      const collection = document.getElementsByClassName("vtl");
      for (let i = 0; i < collection.length; i++) {
        collection[i].querySelector(".vtl-drag-disabled").style.background =
          "transparent";
      }
      this.toggleFileTree();
      await this.setStyle();
      document
        .getElementById(this.getActive)
        .scrollIntoView({ behavior: "smooth" });
    },
    hideFilter() {
      this.showTeamsFilter = false;
      this.showType = false;
      this.showUserRole = false;
      if (!this.showApplyFilter) {
        this.typeSelected = "";
        this.typeOptionSelected = "";
        this.userRoleSelected = [];
      }
    },
    toggleFileTree() {
      const traverseTree = (node, path = []) => {
        if (node.$vnode.key === this.getActive) {
          if (!node.expanded) node.toggle();
          // Toggle all parent nodes of the current node
          this.toggleParents(path);
        } else {
          // Traverse through children if they exist
          if (node.$children && node.$children.length > 0) {
            node.$children.forEach((child) => {
              traverseTree(child, [...path, node]);
            });
          }
        }
      };

      // Start traversal from the top level nodes
      this.$refs["treeView"].$children.forEach((node) => {
        traverseTree(node);
      });
    },
    toggleParents(path) {
      // Reverse the path to toggle from leaf to root
      path.reverse();
      // Toggle each parent node
      path.forEach((node) => {
        if (!this.expandedFolders.includes(node.$vnode.key)) {
          // Node ID doesn't exist in expandedFolders, so add it
          this.expandedFolders.push(node.$vnode.key);
        }
        if (!node.expanded) node.toggle();
      });
    },
    async onCreate() {
      const collection = document.getElementsByClassName("vtl");
      for (let i = 0; i < collection.length; i++) {
        collection[i].querySelector(".vtl-drag-disabled").style.background =
          "transparent";
      }
      await this.executeMethods();
      this.setStyle();
    },
    async searchGroups() {
      this.expandedFolders = [];
      await this.getAllFolders();
      this.loadOrganizationData();
      this.$store.commit("teamsVUEX/setActive", "");
      this.$store.commit("teamsVUEX/addFolderContent", {});
      this.folderUp = {};
      const collection = document.getElementsByClassName("vtl");
      for (let i = 0; i < collection.length; i++) {
        collection[i].querySelector(".vtl-drag-disabled").style.background =
          "transparent";
      }
      // Traverse through each node in the tree
      const traverseTree = (node) => {
        // If the node is expanded, toggle it
        if (node.expanded) {
          node.toggle();
        }
        // Traverse through children if they exist
        if (node.$children && node.$children.length > 0) {
          node.$children.forEach((child) => {
            traverseTree(child);
          });
        }
      };
      // Start traversal from the top level nodes
      this.$refs["treeView"].$children.forEach((node) => {
        traverseTree(node);
      });
    },
    async executeMethods() {
      await this.getAllFolders();
      this.loadOrganizationData();
      this.getSelectedFolder();
    },
    selectNode(node) {
      if (node.id != this.getActive) {
        this.$store.commit("teamsVUEX/setActive", node.id);
        const collection = document.getElementsByClassName("vtl");
        for (let i = 0; i < collection.length; i++) {
          collection[i].querySelector(".vtl-drag-disabled").style.background =
            "transparent";
        }
        if (!this.expandedFolders.includes(node.id)) {
          node.toggle();

          // Node ID doesn't exist in expandedFolders, so add it
          this.expandedFolders.push(node.id);
        }
        this.setStyle();
      } else {
        this.$store.commit("teamsVUEX/setActive", "");
        this.$store.commit("teamsVUEX/addFolderContent", {});
        this.folderUp = {};
        const index = this.expandedFolders.indexOf(node.id);
        if (index !== -1) {
          // Node ID exists in expandedFolders, so remove it
          this.expandedFolders.splice(index, 1);
        }
        document
          .getElementById(node.id)
          .querySelector(".vtl-drag-disabled").style.background = "transparent";
        this.searchInsideFolder = "";
      }
      if (!this.expandedFolders.includes(node.id)) {
        node.toggle();
      }
    },
    // Highlight the active node
    setStyle() {
      if (this.getActive !== "") {
        document
          .getElementById(this.getActive)
          .querySelector(".vtl-drag-disabled").style.background = "#e1eef7";
        this.searchInsideFolder = "";
        if (!this.showApplyFilter) this.getSelectedFolder();
        else this.clearFilter(this.getActive);
      }
    },
    async getSelectedFolder() {
      this.$store.commit("teamsVUEX/setLoader", true);
      let payload = {
        project: "recruitment",
        licenseKey: this.getlicenseKey,
        folderID: this.getActive,
      };
      this.folderUp = await this.$store.dispatch(
        "teamsVUEX/getContent",
        payload
      );
      this.folderUp = this.folderUp.reverse();
      this.$store.commit("teamsVUEX/setLoader", false);
    },
    loadOrganizationData() {
      this.organizationData = this.transformData();
      this.initializeTree();
    },
    initializeTree() {
      this.treeData = new Tree(this.organizationData);
    },
    transformData() {
      return this.getFolders.map((item) => ({
        name: item.folderName,
        id: item.folderID,
        dragDisabled: true,
        addTreeNodeDisabled: true,
        addLeafNodeDisabled: true,
        editNodeDisabled: true,
        delNodeDisabled: true,
        children: this.transformChildren(
          item.childFolders,
          item.folderID || []
        ),
      }));
    },
    transformChildren(children, folderID) {
      return children.map((child) => ({
        name: child.folderName,
        id: child.folderID,
        pid: folderID,
        isLeaf: !child.childFolders || child.childFolders.length == 0,
        dragDisabled: true,
        addTreeNodeDisabled: true,
        addLeafNodeDisabled: true,
        editNodeDisabled: true,
        delNodeDisabled: true,
        children: this.transformChildren(
          child.childFolders,
          child.folderID || []
        ),
      }));
    },
    clearFilter(folderID) {
      if (!this.showApplyFilter) this.hideFilter();
      else {
        this.showApplyFilter = false;
        this.hideFilter();
        this.getFolderDetails(folderID);
      }
    },
    applyFilter(folderID) {
      this.showTeamsFilter = false;
      this.showApplyFilter = true;
      this.showType = false;
      this.showUserRole = false;
      this.typeSelected = this.typeOptionSelected;
      this.getFolderDetails(folderID);
    },
    async getRolesDetails() {
      if (this.showTeamsFilter) {
        try {
          let params = {
            project: "recruitment",
            type: "ALLROLES",
            licenseKey: this.getlicenseKey,
          };
          const res = await getRolesDetails(params);
          if (res.status == 200) {
            this.userRoleOptions = await res.data.data.data;
          }
        } catch (error) {
          this.LoaderStatus = false;
          throw new Error(`Failed! status:${error.status}`);
        }
      }
    },
    setUserIcon() {
      for (let i in this.childFolders) {
        for (let j in this.childFolders[i].users) {
          if (this.childFolders[i].users[j].username.includes(" ")) {
            const first = this.childFolders[i].users[j].username
              .split(" ")[0][0]
              .toUpperCase();
            const sec = this.childFolders[i].users[j].username
              .split(" ")[1][0]
              .toUpperCase();
            this.childFolders[i].users[j].userIcon = first + sec;
          } else {
            const value = this.childFolders[i].users[j].username
              .slice(0, 2)
              .toUpperCase();
            this.childFolders[i].users[j].userIcon = value;
          }
        }
      }
    },
    handleKeyUp(event) {
      if (
        event.keyCode === 13 &&
        this.$refs.deleteFolderModal &&
        this.$refs.deleteFolderModal.isVisible
      ) {
        // If Enter key is pressed, call deleteFolder method
        this.deleteFolder();
      }
      if (
        event.keyCode === 13 &&
        this.$refs.deleteUserModal &&
        this.$refs.deleteUserModal.isVisible
      ) {
        // If Enter key is pressed, call deleteFolder method
        this.deleteUser();
      }
    },
    hideTagUserOptions() {
      this.showUser = false;
    },
    // CREATE FOLDER
    async createFolder() {
      this.$v.$touch();
      if (this.$v.folderName.$error) {
        this.errorModal("Please give folder name");
        return;
      }
      if (
        this.childFolders.some(
          (folder) => folder.folderName === this.folderName
        )
      ) {
        this.errorModal("Folder name already exists");
        return;
      }
      try {
        let payload = {
          licenseKey: this.getlicenseKey,
          folderName: this.folderName,
          parentFolderID: this.getFolderContent.folderID,
          project: "recruitment",
        };
        const response = await addFolder(payload);
        if (response.status == 200) {
          this.toggleFileTree();
          let fetch = this.getFetch;
          this.$store.commit("teamsVUEX/setFetch", !fetch);
          this.closeModel("addSubFolder");
          this.successModal("Folder created successfully");
          this.$v.folderName.$model = "";
        } else {
          this.errorModal(response.data.data.Detail);
        }
        this.$v.$reset();
      } catch (error) {
        this.errorModal("Something went wrong");
      }
    },
    getRole(user) {
      return user.roleName.length < 20
        ? user.roleName
        : user.roleName.substring(0, 21) + "...";
    },

    // TO RENDER ROLE NAME
    getRoleNames(roleName) {
      return roleName.length < 25
        ? roleName
        : roleName.substring(0, 25) + "...";
    },

    // TO RENDER ROLES
    getRoles(index) {
      let temp = this.users[index].roles.join(",");
      this.users[index].pop = temp.substring(0, temp.length - 1);
      if (temp.length > 25) {
        return temp.substring(0, 25) + "...";
      }
      return temp.substring(0, temp.length - 1);
    },

    // DELETE A FOLDER
    async deleteFolder() {
      this.showSpinnerCircle = true;
      try {
        let payload = {
          licenseKey: this.getlicenseKey,
          folderID: this.deleteSelectedFolder.folderID,
          project: "recruitment",
          action: "folder",
        };
        const response = await deleteFolderUser(payload);
        if (response.status == 200) {
          if (!this.deleteFromInside) {
            this.$store.commit("teamsVUEX/addFolderContent", {});
            this.$store.commit("teamsVUEX/setActive", "");
          }
          this.deleteType = false;
          this.closeModel("delete-folder");
          this.successModal("Folder deleted successfully");
          await this.getAllFolders();
          this.loadOrganizationData();
          if (this.deleteFromInside) {
            this.getFolderDetails(this.getActive);
          }
        } else {
          this.errorModal(response.data.data.Detail);
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      } finally {
        this.showSpinnerCircle = false;
      }
    },

    //DELETE USER
    async deleteUser() {
      this.showSpinnerCircle = true;
      try {
        let payload = {
          licenseKey: this.getlicenseKey,
          folderID: this.getFolderContent.folderID,
          project: "recruitment",
          action: "user",
          users: [this.deleteSelectedUser.userID],
        };
        const response = await deleteFolderUser(payload);
        if (response.status == 200) {
          this.getFolderDetails(this.getFolderContent.folderID);
          this.closeModel("delete-user");
          this.successModal("User deleted successfully");
        } else {
          this.errorModal(response.data.data.Detail);
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      } finally {
        this.showSpinnerCircle = false;
      }
    },

    //RENAME A FOLDER
    async rename() {
      if (this.renameFolder.folderName.length == 0) {
        this.errorModal("Please give folder name");
        return;
      }
      try {
        let payload = {
          licenseKey: this.getlicenseKey,
          folderName: this.renameFolder.folderName,
          folderID: this.renameFolder.folderID,
          project: "recruitment",
          action: "folder",
        };
        const response = await addFolderUser(payload);
        if (response.status == 200) {
          this.getFolderDetails(this.getFolderContent.folderID);
          this.executeMethods();
          this.closeModel("rename-folder");
          this.successModal("Folder renamed successfully");
        } else {
          this.errorModal(response.data.data.Detail);
        }
      } catch (error) {
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    // ASSIGN THE SELECTED FOLDER DETAIL TO ANOTHER VARIABLE BEFORE DELETING
    assignFolder(folder) {
      this.deleteSelectedFolder = { ...folder };
      this.$bvModal.show("delete-folder");
    },

    // ASSIGN THE SELECTED USER DETAIL TO ANOTHER VARIABLE BEFORE DELETING
    assignUser(user) {
      this.deleteSelectedUser = { ...user };
      this.$bvModal.show("delete-user");
    },

    // ASSIGN THE SELECTED FOLDER NAME TO ANOTHER VARIABLE BEFORE RENAMING
    assignFolderName(folder) {
      this.renameFolder = { ...folder };
      this.$bvModal.show("rename-folder");
    },

    // DYNAMIC FUNCTION FOR CLOSING MODEL
    closeModel(model) {
      this.$v.$reset();
      this.$bvModal.hide(model);
    },
  },
};
</script>

<style>
.child-list {
  height: calc(100vh - 428px);
  background: #ffffff;
  box-shadow: 0px 0px 14px rgb(196 196 196 / 50%);
  border-radius: 5px;
  overflow: auto;
  align-content: flex-start;
  z-index: 2;
  position: relative;
}

.table-data {
  vertical-align: middle;
  width: 28%;
}

.no-user-text {
  font-size: 12px;
  font-weight: 400;
  color: #696969;
}

.no-user-main {
  font-size: 12px;
  font-weight: 500;
  color: #696969;
}

.no-user-box {
  background: #fcfcfc;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  padding: 10px;
  margin: 0px 5px 5px 0px;
  z-index: 3;
  position: relative;
  height: calc(100vh - 435px);
}

.folder-right {
  background: #ffffff;
  box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  padding: 15px;
  overflow: hidden;
  width: 100%;
}

.created-date {
  font-weight: 400;
  font-size: 13px;
  color: #696969;
}

.teams-right-container {
  place-items: center;
  width: 75%;
  height: calc(100vh - 175px);
  overflow: auto;
}

.folder-right-foldercontainer {
  background: #fcfcfc;
  border: 1px solid #ededed;
  box-shadow: 0px 16px 40px rgba(129, 128, 128, 0.25);
  border-radius: 4px;
  padding: 15px;
  width: 320px;
  height: 105px;
}

.right-folder-mainheading {
  font-weight: 600;
  font-size: 18px;
  color: #464667;
}

.error {
  border: 1px solid red !important;
  border-radius: 8px;
}

.folder-count-box {
  background: #f1f1f1;
  border: 1px solid #ededed;
  border-radius: 4px;
  width: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}

.teams-empty-svg {
  position: absolute;
  transform: translate(75%, 50%);
}

.teams-left-folder-conatiner {
  background: #f3f3f3;
  padding: 8px 8px 0px 8px;
  width: 25%;
  height: calc(100vh - 190px);
  overflow-y: scroll;
}

.root-folder-box {
  background: #fcfcfc;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
}

.root-folder-active-box {
  background: #3e85bd;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
}

.root-folder-text {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}

.gridgreencolorDynamic {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  top: 2px;
  left: 3px;
  background: #696969;
}

.gridwhitecolor {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  top: 2px;
  left: 3px;
  background: #f6f6f6;
}

.root-folder-active-text {
  font-weight: 500;
  font-size: 14px;
  color: #fcfcfc;
}

.right-folder-txt {
  font-weight: 400;
  font-size: 12px;
  color: #696969;
}

.user-listing {
  min-height: auto;
  max-height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.select-users {
  margin-right: 15px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  background: #e7e8f5;
  border-radius: 3px;
}

.user-name {
  padding: 3px 10px 2px 10px;
}

.close-img {
  padding-right: 8px;
}

.tf-backarrow {
  position: absolute;
  top: 0px;
}

.teams-whitebtn {
  border-radius: 3px;
  color: var(--bg-tertiary);
  background-color: var(--bg-white);
  font-size: var(--size-13);
  border: 1px solid var(--btn-border);
}

.teams-white-btn .btn-secondary:hover {
  color: var(--bg-tertiary);
  background-color: var(--bg-white);
  border-color: none !important;
}

.teams-white-btn .btn-secondary:focus,
.btn-secondary.focus {
  color: var(--bg-tertiary);
  background-color: var(--bg-white);
  border-color: none;
  box-shadow: none;
}

/* to give the checkbox pointer in tag user modal when we try to search particular user -- the default bootstrap class is being used */
.custom-control-label {
  position: relative;
  margin-bottom: 0;
  cursor: pointer;
  vertical-align: top;
}

/* when we scrolldown background color of the scroll should not change -- it is used near the folders structure */
#style-scrollbar::-webkit-scrollbar-track {
  background-color: #e5e5e5;
}

.teams-active-tab .tabbed .nav-tabs .nav-link.active {
  background: #72738e;
  border: 1px solid #72738e;
  font-weight: 500;
  font-size: 14px;

  margin-top: -1px;

  color: #ffffff;
  text-align: center;
}
.tf-email {
  font-size: 12px;
}

.teams-active-tab .nav-tabs {
  border-bottom: none !important;
}

.roundDarkBlue {
  width: 30px;
  height: 30px;
  background-color: #20639b;
  border: 1px solid white;
  border-radius: 50%;
  font-size: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.roundLightBlue {
  width: 30px;
  height: 30px;
  background-color: #e9f0f5;
  border: 1px solid white;
  border-radius: 50%;
  font-size: 10px;
  color: #20639b;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.cj-noofrecoption {
  color: #495057;
}
.rec-dd-group {
  width: 100%;
  min-height: auto;
  max-height: 25vh;
  overflow: auto;
}
.custom-switch
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: #85b0d4;
  border-color: #85b0d4;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #85b0d4;
  border-color: white;
}

.teams-main-container-height {
  height: 82%;
}

.teams-list-view .vtl-node {
  font-family: "lato", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: black;
  cursor: pointer;
}

.teams-list-view .vtl {
  background: #fff;
  border: 1px solid rgba(140, 140, 140, 0.33);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}

.teams-list-view .vtl .vtl {
  background: #fff;
  border: none;
  box-shadow: none;
  border-radius: none;
  padding: 0;
  margin: 0;
}

.teams-list-view .vtl-icon-folder:before {
  content: "";
}

.teams-list-view .vtl-icon-file:before {
  content: "";
}

.teams-list-view .vtl-icon {
  display: none;
}

.teams-list-view .vtl-border.vtl-bottom {
  background-color: rgba(140, 140, 140, 0.33);
  height: 1px;
  margin: 15px 0;
  width: calc(100% + 30px);
  padding: 0;
  position: relative;
  right: 20px;
}

.teams-list-view .vtl .vtl .vtl-border.vtl-bottom {
  background-color: transparent;
  height: 0;
  width: 0;
  margin: 0;
  padding: 0;
}

.teams-list-view .vtl .vtl-drag-disabled:hover {
  background: #e1eef7 !important;
}

.teams-list-view .vtl .vtl .vtl-node-main {
  padding: 5px 0;
  margin-bottom: 5px;
  word-break: break-word;
}

.teams-list-view .vtl .vtl .vtl-node-main .vtl-operation {
  margin-left: unset !important;
  letter-spacing: unset !important;
}

.teams-list-view img {
  position: relative;
  bottom: 1px;
}

.teams-list-view .vtl-tree-margin {
  margin-left: 20px;
}

.teams-filter-applied {
  position: absolute;
  top: 1px;
  left: 25px;
}

.selectCustom-dropdown-text {
  font-size: 11px !important;
}

.loader-pos {
  position: absolute;
  top: 55px;
  z-index: 1;
  right: 100px;
}

.mp-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 84px;
}
</style>
